import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '15px'
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmitProduct = async (event) => {
    event.preventDefault();

    const productName = event.target.elements.productname.value;
    const productPrice = event.target.elements.productprice.value;
    const productPageUrl = event.target.elements.producturl.value;
    const productDetails = event.target.elements.productdetails.value;

    const product = {
      name: productName,
      price: productPrice,
      pageUrl: productPageUrl,
      details: productDetails,
    };

    try {
      await addDoc(collection(db, 'ProductList'), product);
      console.log('Produit ajouté avec succès à Firebase');
    } catch (error) {
      console.error("Erreur lors de l'ajout du produit à Firebase:", error);
    }

    handleClose();
  };

  return (
    <div>
      <button style={{
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '100%',
              height: '50px',
              width: '50px',
              padding: '5px',
              paddingLeft: '20px',
              paddingRight: '20px',
              boxShadow: '0 0 10px 1px blue',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              gap: '5px' }} onClick={handleOpen}><AddIcon /></button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h1 style={{ textAlign: 'center', marginBottom: '30px', fontWeight: '800' }}>Add a product</h1>
          <form style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} onSubmit={handleSubmitProduct}>
            <label style={{ marginBottom: '10px' }}>Product name</label>
            <input style={{ border: '1px solid gray', borderRadius: '5px', padding: '5px' }} type="text" name="productname" id="productname" placeholder="Juice Blender" />
            <label style={{ marginTop: '30px', marginBottom: '10px' }}>Price</label>
            <input style={{ border: '1px solid gray', borderRadius: '5px', padding: '5px' }} type="number" name="productprice" id="productprice" placeholder="$19" />
            <label style={{ marginTop: '30px', marginBottom: '10px' }}>Page URL</label>
            <input style={{ border: '1px solid gray', borderRadius: '5px', padding: '5px' }} type="text" name="producturl" id="producturl" placeholder="https://example.com/product" />
            <label style={{ marginTop: '30px', marginBottom: '10px' }}>Details</label>
            <input style={{ border: '1px solid gray', borderRadius: '5px', padding: '5px' }} type="text" name="productdetails" id="productdetails" placeholder="Amazing blender that is ..." />
            <button style={{ backgroundColor: '#2dbc47', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '15px', padding: '10px', marginTop: '30px' }} type="submit">Submit product</button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
